export const enum UniversalFilterDateIsWithinModeOptions {
  THE_PAST_WEEK = 'the_past_week',
  THE_PAST_MONTH = 'the_past_month',
  THE_PAST_YEAR = 'the_past_year',
  THE_NEXT_WEEK = 'the_next_week',
  THE_NEXT_MONTH = 'the_next_month',
  THE_NEXT_YEAR = 'the_next_year',
  THIS_CALENDAR_WEEK = 'this_calendar_week',
  THIS_CALENDAR_MONTH = 'this_calendar_month',
  THIS_CALENDAR_YEAR = 'this_calendar_year',
  THE_NEXT_NUMBER_OF_DAYS = 'the_next_number_of_days',
  THE_PAST_NUMBER_OF_DAYS = 'the_past_number_of_days'
}
